import { getLocaleNumberSymbol, NumberSymbol } from '@angular/common';

export const defaultLocaleId = 'en';

export const defaultDecimalSeparator = getLocaleNumberSymbol(
  defaultLocaleId,
  NumberSymbol.Decimal,
);
